// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1c7c7475","239":"4dda6de1","251":"09cde904","307":"61fe0e79","316":"dea2c32e","377":"c31a66a6","455":"fe6c1a76","583":"a6b9f0a0","628":"f2c4b6f7","725":"c4407690","796":"43af0486","859":"44d47ff7","938":"698f62d2"}[chunkId] + ".chunk.js";
};